import * as actionType from "./BudgetAction";
import { ApiGateWay } from "../../../ApiGateWay/ApiGateWay";
import { Config } from "../../../config/config";
import Cookie from "js-cookie";
import LZString from 'lz-string';

const config = JSON.parse(Config);
const apiInterface = config["api1"];
console.log(apiInterface, "apiinterface");
const initialState = {
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};
export const apiCallStatus = (data) => (dispatch) => {
  dispatch(apiStatus(data));
};
export const apiStatus = (data) => ({
  type: actionType.API_CALL_STATUS,
  payload: data,
});
export const GetMainCategoryList = (data) => ({
  type: actionType.GET_ALL_MAIN_CATEGORY_DATA,
  payload: data,
});
export const GetLoadRemarksforBudget = (data)=>({
  type : actionType.GET_LOAD_REMARKS_FOR_BUDGET,
  payload: data,
})
export const GetLoadBudgetSOMData = (data) => ({
  type: actionType.GET_LOAD_BUDGET_SOM_DATA,
  payload: data,
});
export const ClearingSelectedBudgetTypeData = () => ({
  type: actionType.CLEAR_ALL_DATA,
});
export const approveOrRejectStatus = (data) => ({
  type: actionType.STATUS_UPDATE,
  payload : data,
});

export const GetAllMainCategoryList = () => async (dispatch) => {
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData);
    let data = {
    fedid:user['userId']
  }
  initialState.loading = true;
  // dispatch(apiStatus(initialState))
  ApiGateWay.SaveData(apiInterface + "/BudgetPlanner/loadallmaincategories",data)
    .then((response) => {
      initialState.loading = false;
      if (response[0]?.Table1[0]?.status_code == "000") {
        const MainCategoryList = [];
        response[1].Table2.forEach((ele) => {
          MainCategoryList.push({
            id: ele.id,
            main_category_name: ele.main_category_name,
            active: ele.active == 0 ? "Inactive" : "Active",
            preventive_maintenance: ele.preventive_maintenance,
            corrective_maintenance: ele.corrective_maintenance,
            maintenance_annual_expenses: ele.maintenance_annual_expenses,
            maintenance_annual_investment: ele.maintenance_annual_investment,
            tpv_audit: ele.tpv_audit,
            house_keeping: ele.tpv_audit,
            security_services: ele.security_services,
            energy_other_bills: ele.energy_other_bills,
          });
        });
        const StoresList = response[2].Table3;
        // initialState.message = response[0]?.Table1[0]?.status_msg;
        initialState.modalOpen = false;
        initialState.loading = false;
        const AllData = {MainCategoryList,StoresList} 
    // dispatch(apiStatus(initialState))
        dispatch(GetMainCategoryList(AllData));
        // dispatch(apiCallStatus(initialState))
      } else {
        initialState.apiStatus = false;
        initialState.loading = false;
        initialState.modalOpen = true;
        initialState.message = response[1]?.Table1[2]?.status_msg;
      }
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
    });
};

export const updateBudget = (value) => async (dispatch) => {
  const user = JSON.parse(Cookie.get("currentUser"));
  initialState.loading = true;
  ApiGateWay.SaveData(
    apiInterface + "/BudgetPlanner/updatebudgetcategories",
    value
  )
    .then((response) => {
      initialState.loading = false;
      if (response[0]?.Table1[0]?.status_code == "000") {
        initialState.message = response[0]?.Table1[0]?.status_msg;
        initialState.modalOpen = false;
      } else {
        initialState.apiStatus = false;
        initialState.loading = false;
        initialState.modalOpen = true;
        initialState.message = response[1]?.Table1[2]?.status_msg;
      }
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
    });
};

export const LoadBudgetSOM = (values) => async (dispatch) => {
  const user = JSON.parse(Cookie.get("currentUser"))
  console.log(user,'user')
  initialState.loading = true;
  ApiGateWay.SaveData(apiInterface + "/BudgetPlanner/LoadBudgetSOM",values)
    .then((response) => {
      initialState.loading = false;
      if (response[0]?.Table1[0]?.status_code == "000") {

        const StoresList = response[1].Table2;
        const SelectedBudgetTypeData = [];
        response[2].Table3.forEach(ele=>{
          SelectedBudgetTypeData.push({
          budget_id: ele.budget_id,
          current_actual_bcp_budget: ele.current_actual_bcp_budget,
          current_actual_budget: ele.current_actual_budget,
          current_realised_bcp_budget: ele.current_realised_bcp_budget,
          current_realised_budget: ele.current_realised_budget,
          finanace_team_status: (ele.finanace_team_status ==null ||ele.finanace_team_status== "0" || ele.finanace_team_status == '') ? "Pending": ele.finanace_team_status== "1" ? "Approved": ele.finanace_team_status== "2" && "Rejected",
          id: ele.id,
          main_category_name: ele.main_category_name,
          previous_actual_bcp_budget: ele.previous_actual_bcp_budget,
          previous_actual_budget: ele.previous_actual_budget,
          previous_realised_bcp_budget: ele.previous_realised_bcp_budget,
          previous_realised_budget: ele.previous_realised_budget,
          som_status: (ele.som_status==null ||ele.som_status== 0 || ele.som_status == '') ? "Pending": ele.som_status== 1 ? "Approved": ele.som_status== 2 && "Rejected",
          store_id: ele.store_id,
          store_name: ele.store_name,
          zomc_status: (ele.zomc_status==null ||ele.zomc_status== 0 || ele.zomc_status == '') ? "Pending": ele.zomc_status== 1 ? "Approved": ele.zomc_status== 2 && "Rejected"
          })
        })
        initialState.message = response[0]?.Table1[0]?.status_msg;
        initialState.modalOpen = false;
        const LoadBudgetSOM ={StoresList, SelectedBudgetTypeData}
        dispatch(GetLoadBudgetSOMData(LoadBudgetSOM));
        // dispatch(apiCallStatus(initialState))
      } else {
        initialState.apiStatus = false;
        initialState.loading = false;
        initialState.modalOpen = true;
        initialState.message = response[1]?.Table1[2]?.status_msg;
      }
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
    });
};

export const updatebudgetplannersom = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/BudgetPlanner/updatebudgetplannersom', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                initialState.loading = false;
                dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.message = result[1].Table1[2].status_msg;
                initialState.loading = false;
                dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
        })
}
export const approveorrejectbudgetplanner = (values) => async (dispatch) => {
    initialState.loading = true;
    let message
    if(values.actiontype ==1)
      message = 'Approved'
    else if(values.actiontype ==2)
      message = 'Rejected'
    let statusInfo ={
      statusmessage:message
    }
    // dispatch(APIStart(initialState))
    ApiGateWay.SaveData(apiInterface + '/BudgetPlanner/approveorrejectbudgetplanner', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(approveOrRejectStatus(statusInfo))
                // dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.message = result[1].Table2[0].status_msg
                statusInfo.statusmessage = 'Pending'
                dispatch(approveOrRejectStatus(statusInfo))
                // dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            statusInfo.statusmessage = 'Pending'
            dispatch(approveOrRejectStatus(statusInfo))
            // dispatch(apiStatus(initialState))
        })
}
export const LoadRemarksforBudget = (values) => async (dispatch) => {
    initialState.loading = true;
    // dispatch(APIStart(initialState))
    ApiGateWay.SaveData(apiInterface + '/BudgetPlanner/LoadRemarksforBudget', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                const RemarksData = result[1].Table2;
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(GetLoadRemarksforBudget(RemarksData))
                // dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.message = result[1]?.Table1[2]?.status_msg
                // dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(apiStatus(initialState))
        })
}
